import { cn } from "@/lib/utils";

interface LeakWarningProps {
  /** Tracked brand names found in the prompt text. */
  brandNames: string[];
  /** Noun describing the run kind, e.g. "blind query", "blind query report". */
  context: string;
  /** Compact variant (used in the Compare panel). */
  compact?: boolean;
  className?: string;
}

/**
 * Amber callout warning that selected tracked brand names appear in a blind-query
 * prompt. Renders nothing when there are no leaked names.
 */
export function LeakWarning({ brandNames, context, compact, className }: LeakWarningProps) {
  if (brandNames.length === 0) return null;
  const plural = brandNames.length === 1 ? "" : "s";
  return (
    <div
      className={cn(
        "rounded-lg border border-amber-200 bg-amber-50",
        compact ? "px-3 py-2" : "px-4 py-3",
        className,
      )}
    >
      <p className={cn("text-amber-800 leading-relaxed", compact ? "text-[12px]" : "text-[13px]")}>
        This prompt appears to mention selected tracked brand{plural}: {brandNames.join(", ")}. For a true {context}, remove those names from the prompt text.
      </p>
    </div>
  );
}
